import React from "react";
import { Box, Skeleton, TableCell, TableRow } from "@mui/material";

interface OcDataTableLoadingRowsProps {
  rows: number;
  columns: string[];
}

export const OcDataTableLoadingRows: React.FC<OcDataTableLoadingRowsProps> = ({
  rows,
  columns,
}) => {
  const selectType = (item: "avatar" | "radio" | "checkbox" | string) => {
    switch (item) {
      case "avatar":
        return (
          <Box display="flex" justifyContent="center" marginLeft="-8px">
            <Skeleton
              animation="wave"
              variant="circular"
              height={34}
              width={34}
            />
          </Box>
        );
      case "radio":
        return (
          <Box
            id="avatar"
            display="flex"
            flexDirection="row"
            justifyContent="center"
            padding="4px 0px 4px 0px"
          >
            <Skeleton
              animation="wave"
              variant="circular"
              height={24}
              width={24}
            />
          </Box>
        );
      case "checkbox":
        return (
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            paddingLeft="8px"
          >
            <Skeleton variant="rectangular" width={18} height={18} />
          </Box>
        );
      default:
        return (
          <Skeleton variant="text" animation="wave" height={30} width="auto" />
        );
    }
  };

  const generateRow = (rowIndex: number) => (
    <TableRow key={`skeleton-row-${rowIndex}`}>
      {columns.map((item, colIndex) => (
        <TableCell
          key={`skeleton-cell-${rowIndex}-${colIndex}`}
          style={{ padding: "2px 8px 2px 8px", lineHeight: "22px" }}
        >
          <Box display="flex" flexDirection="column" justifyContent="center">
            {selectType(item)}
          </Box>
        </TableCell>
      ))}
    </TableRow>
  );

  let result = [];
  for (let index = 0; index < rows; index++) {
    result.push(generateRow(index));
  }
  return <>{result}</>;
};

export default OcDataTableLoadingRows;
